import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';

/**
 * Versão atual dos termos e condições (data da página /terms-and-conditions).
 * Ao publicar uma nova versão dos termos, mudar este valor: o popup volta a
 * aparecer a todos os utilizadores até aceitarem.
 */
export const TERMS_VERSION = '2026-11-01';

@Component({
  selector: 'terms-update-popup',
  templateUrl: './terms-update-popup.component.html',
  styleUrls: ['./terms-update-popup.component.scss']
})
export class TermsUpdatePopupComponent implements OnInit, OnDestroy {
  showPopup: boolean = false;
  accepted: boolean = false;

  private userId: string = '';
  private subscription: Subscription;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.subscription = this.userService.user.subscribe(u => {
      this.userId = u?.id || '';
      this.showPopup = this.userId != '' && localStorage.getItem(this.storageKey()) != TERMS_VERSION;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  accept() {
    if (!this.accepted) return;
    localStorage.setItem(this.storageKey(), TERMS_VERSION);
    this.showPopup = false;
  }

  private storageKey(): string {
    return `termsAccepted_${this.userId}`;
  }
}
